// Client wrapper for the account endpoints on the api service (served same-origin
// at /api/account/*). Owner self-signup moved server-side when the console went
// multi-tenant: register() now creates the recruiter login + their `accounts` and
// `billing` records together (both superuser-only collections the browser can't
// write), then returns a session to adopt — the same shape as acceptInvite.

import type { RecordModel } from 'pocketbase'

const BASE = '/api/account'

/** Public: create an owner account (login + account + free billing); returns a
 *  session token + record for the caller to adopt into pb.authStore. */
export async function registerAccount(input: {
  email: string
  password: string
  role: string
}): Promise<{ token: string; record: RecordModel }> {
  const res = await fetch(`${BASE}/register`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  })
  const data = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error((data as { error?: string })?.error || 'Could not create your account.')
  return data as { token: string; record: RecordModel }
}
